// extracted by mini-css-extract-plugin
export default {"notFound":"NotFound_notFound__BEDid","linkStyle":"NotFound_linkStyle__Vm1DX"};